import MouseWithinExample from "./examples/MouseWithin.Example";

export default [
    {
        title: "MouseWithin example",
        component: MouseWithinExample,
        code: require("!raw-loader!./examples/MouseWithin.Example.tsx")
    }
];
